import { ViewModel, View } from "binder"
import { UsageAmountEditorView } from "./usageAmountEditor-view"
import { IUsageAmount } from "../IUsageAmount";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ToolModel, ToolModelSelectorViewModel } from "../../toolModelFromProducerManipulation/toolModelSelector-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { ToolPlace, ToolPlaceSelectorViewModel } from "../selectors/toolPlaceSelector-viewModel";
import { ToolModelFromProducer, ToolModelFromProducerSelectorViewModel } from "../selectors/toolModelFromProducerSelector-viewModel";
import { Activity, ActivitySelectorViewModel } from "../selectors/activitySelector-viewModel";
import { ToolStatus, ToolStatusSelectorViewModel } from "../selectors/toolStatusSelector-viewModel";
import { OPC, OPCSelectorViewModel } from "../selectors/opcSelector-viewModel";

export class UsageAmountEditorViewModel extends ViewModel implements IUsageAmount, IPopup {
    constructor(parentViewModel: ViewModel, updater: IServerUpdater) {
        super(parentViewModel);
        this._serverUpdater = updater;

        this.toolModelFromProducerSelector = new ToolModelFromProducerSelectorViewModel(this);
        this.toolStatusSelector = new ToolStatusSelectorViewModel(this);
        this.toolPlaceSelector = new ToolPlaceSelectorViewModel(this);
        this.activitySelector = new ActivitySelectorViewModel(this);

        this.toolModelSelector = new ToolModelSelectorViewModel(this);
        this.toolModelSelector.onSelectionChanged = x => {
            this.onToolModelChanged(x);

            this.toolModelFromProducerSelector.toolModelId = x.id;
            this.toolModelFromProducerSelector.refresh();
            this.toolModelFromProducerSelector.onSelectionChanged = x => this.onToolModelFromProducerChanged(x);

            this.toolStatusSelector.toolModelId = x.id;
            this.toolStatusSelector.refresh();
            this.toolStatusSelector.onSelectionChanged = x => this.onToolStatusChanged(x);

            this.toolPlaceSelector.toolModelId = x.id;
            this.toolPlaceSelector.refresh();
            this.toolPlaceSelector.onSelectionChanged = x => this.onToolPlaceChanged(x);
        }

        this.opcSelector = new OPCSelectorViewModel(this);
        this.opcSelector.onSelectionChanged = x => {
            this.onOPCChanged(x);

            this.activitySelector.opcId = x.id;
            this.activitySelector.refresh();
            this.activitySelector.onSelectionChanged = x => this.onActivityChanged(x);
        }
    }
    GetDefaultView(): View<ViewModel> {
        return new UsageAmountEditorView();
    }
    public getTypeId(): string {
        return "VM-63D156BD-479B-4AEB-9570-12F8ECAC7C63"
    }

    private _serverUpdater: IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount; } private _amount: number;
    public set toolModelId(v: string) { this._toolModelId = v; } public get toolModelId(): string { return this._toolModelId; } private _toolModelId: string;
    public set toolModelSelector(v: ToolModelSelectorViewModel) { this._toolModelSelector = v; } public get toolModelSelector(): ToolModelSelectorViewModel { return this._toolModelSelector; } private _toolModelSelector: ToolModelSelectorViewModel;
    public set toolPlaceId(v: string) { this._toolPlaceId = v; } public get toolPlaceId(): string { return this._toolPlaceId; } private _toolPlaceId: string;
    public set toolPlaceSelector(v: ToolPlaceSelectorViewModel) { this._toolPlaceSelector = v; } public get toolPlaceSelector(): ToolPlaceSelectorViewModel { return this._toolPlaceSelector; } private _toolPlaceSelector: ToolPlaceSelectorViewModel;
    public set toolModelFromProducerId(v: string) { this._toolModelFromProducerId = v; } public get toolModelFromProducerId(): string { return this._toolModelFromProducerId; } private _toolModelFromProducerId: string;
    public set toolModelFromProducerSelector(v: ToolModelFromProducerSelectorViewModel) { this._toolModelFromProducerSelector = v; } public get toolModelFromProducerSelector(): ToolModelFromProducerSelectorViewModel { return this._toolModelFromProducerSelector; } private _toolModelFromProducerSelector: ToolModelFromProducerSelectorViewModel;
    public set activityId(v: string) { this._activityId = v; } public get activityId(): string { return this._activityId; } private _activityId: string;
    public set activitySelector(v: ActivitySelectorViewModel) { this._activitySelector = v; } public get activitySelector(): ActivitySelectorViewModel { return this._activitySelector; } private _activitySelector: ActivitySelectorViewModel;
    public set toolStatusId(v: string) { this._toolStatusId = v; } public get toolStatusId(): string { return this._toolStatusId; } private _toolStatusId: string;
    public set toolStatusSelector(v: ToolStatusSelectorViewModel) { this._toolStatusSelector = v; } public get toolStatusSelector(): ToolStatusSelectorViewModel { return this._toolStatusSelector; } private _toolStatusSelector: ToolStatusSelectorViewModel;
    public set opcId(v: string) { this._opcId = v; } public get opcId(): string { return this._opcId; } private _opcId: string;
    public set opcSelector(v: OPCSelectorViewModel) { this._opcSelector = v; } public get opcSelector(): OPCSelectorViewModel { return this._opcSelector; } private _opcSelector: OPCSelectorViewModel;

    closePopup(result?: any) {

    }


    onToolModelChanged(toolModel: ToolModel) {
        this.toolModelId = toolModel?.id;
    }

    setToolModelId(id: string) {
        this.toolModelSelector.selectById(id);
    }

    getToolModelId(): string {
        return this.toolModelSelector.selectedItem?.id;
    }


    onToolPlaceChanged(toolPlace: ToolPlace) {
        this.toolPlaceId = toolPlace?.id;
    }

    setToolPlaceId(id: string) {
        this.toolPlaceSelector.selectById(id);
    }

    getToolPlaceId(): string {
        return this.toolPlaceSelector.selectedItem?.id;
    }


    onToolModelFromProducerChanged(toolModelFromProducer: ToolModelFromProducer) {
        this.toolModelFromProducerId = toolModelFromProducer?.id;
    }

    setToolModelFromProducerId(id: string) {
        this.toolModelFromProducerSelector.selectById(id);
    }

    getToolModelFromProducerId(): string {
        return this.toolModelFromProducerSelector.selectedItem?.id;
    }


    onOPCChanged(opc: OPC) {
        this.opcId = opc?.id;
    }

    setOPCId(id: string) {
        this.opcSelector.selectById(id);
    }

    getOPCId(): string {
        return this.opcSelector.selectedItem?.id;
    }


    onActivityChanged(activity: Activity) {
        this.activityId = activity?.id;
    }

    setActivityId(id: string) {
        this.activitySelector.selectById(id);
    }

    getActivityId(): string {
        return this.activitySelector.selectedItem?.id;
    }


    onToolStatusChanged(toolStatus: ToolStatus) {
        this.toolStatusId = toolStatus?.id;
    }

    setToolStatusId(id: string) {
        this.toolStatusSelector.selectById(id);
    }

    getToolStatusId(): string {
        return this.toolStatusSelector.selectedItem?.id;
    }


    async cloneTo(usageAmount: IUsageAmount) {
        usageAmount.id = this.id;
        usageAmount.amount = this.amount;
        usageAmount.setToolModelId(this.getToolModelId());
        usageAmount.setToolModelFromProducerId(this.getToolModelFromProducerId());
        usageAmount.setToolStatusId(this.getToolStatusId());
        usageAmount.setOPCId(this.getOPCId());
        usageAmount.setActivityId(this.getActivityId());
        usageAmount.setToolPlaceId(this.getToolPlaceId());
    }

    back() {
        this.closePopup(null);
    }

    async save() {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در ثبت میزان مصرف ابزار');
            return;
        } else {
            try {
                this.isLoading = true;
                let result = await this._serverUpdater.execute(this);
                if (result.IsSuccessful == false) {
                    if (result.Faults[0].Parameters.FaultId == '0444EA07-B96F-44B0-9432-47851CEB6078') {
                        await this.messageBoxConfirmWarning('اطلاعات به اشتباه وارد شده است.', 'خطا در عملیات');
                    }
                }
                else {
                    await this.messageBoxConfirmSuccess('میزان مصرف ابزار با موفقیت ثبت شد.', 'ثبت موفق');
                    this.closePopup('done');
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning('خطا در ثبت میزان مصرف ابزار', 'خطا در عملیات');
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.getToolModelId())) {
            result.push('مدل ابزار مشخص نشده است.');
        }
        if (this.amount == null || this.amount == 0) {
            result.push('میزان مصرف مشخص نشده است.');
        }
        return result;
    }
}

export interface IServerUpdater {
    execute(usageAmount: IUsageAmount): Promise<any>;
}

export class UsageAmountInserter implements IServerUpdater {
    async execute(usageAmount: IUsageAmount): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/UsageAmountServices/CreateUsageAmount', {
                Amount: usageAmount.amount,
                ToolModelId: usageAmount.getToolModelId(),
                ToolModelFromProducerId: usageAmount.getToolModelFromProducerId(),
                ToolValidStatusId: usageAmount.getToolStatusId(),
                OpcId: usageAmount.getOPCId(),
                ActivityId: usageAmount.getActivityId(),
                ToolPlaceId: usageAmount.getToolPlaceId()
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}

export class UsageAmountUpdater implements IServerUpdater {
    async execute(usageAmount: IUsageAmount): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/UsageAmountServices/UpdateUsageAmount', {
                UsageAmountId: usageAmount.id,
                Amount: usageAmount.amount,
                ToolModelId: usageAmount.getToolModelId(),
                ToolModelFromProducerId: usageAmount.getToolModelFromProducerId(),
                ToolValidStatusId: usageAmount.getToolStatusId(),
                OpcId: usageAmount.getOPCId(),
                ActivityId: usageAmount.getActivityId(),
                ToolPlaceId: usageAmount.getToolPlaceId()
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}
